import { render, staticRenderFns } from "./EvorestSettings.vue?vue&type=template&id=7c4206ce"
import script from "./EvorestSettings.vue?vue&type=script&lang=ts"
export * from "./EvorestSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports